module.exports = __webpack_public_path__ + "img/p4.817ac727.png";